module.exports = __webpack_public_path__ + "img/48.5b9ae632.jpg";